import { z } from "zod/v4"
import { PredefinedAliasId } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"


export class PredefinedAliases {

  public static readonly ALIAS_MIN_LENGTH = 1
  public static readonly ALIAS_MAX_LENGTH = 15 // Users.ALIAS_MAX_LENGTHの半分

  static toDocumentData(predefinedAliasDocument: PredefinedAliasDocument): object {
    return {
      ...predefinedAliasDocument,
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): PredefinedAliasDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: PredefinedAliasId(doc.id),
      value: data["value"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}

export type PredefinedAliasValue = z.infer<typeof PredefinedAliasValue>

export const PredefinedAliasValue = z.object({
  value: z.string().min(PredefinedAliases.ALIAS_MIN_LENGTH).max(PredefinedAliases.ALIAS_MAX_LENGTH).describe("二つ名の文字列"),
})

export const PredefinedAliasDocumentBody = z.intersection(
  PredefinedAliasValue,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt
  })
)

export type PredefinedAliasDocumentBody = z.infer<typeof PredefinedAliasDocumentBody>

export type PredefinedAliasDocument = PredefinedAliasDocumentBody & {
  id: PredefinedAliasId,
}
